import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const ExpressLogo: React.FC<IconV1Props> = ({
  height = '27',
  icon,
  width = '173',
}) => (
  <svg
    className={cn(s.svg, 'svg-icon--expressLogo')}
    viewBox="0 0 173 27"
    width={width}
    height={height}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-634.000000, -61.000000)" fill="#000000">
        <g transform="translate(1.000000, 39.000000)">
          <g transform="translate(633.000000, 21.000000)">
            <g transform="translate(0.000000, 1.360544)">
              <polygon
                id="E"
                fillRule="nonzero"
                points="0 25.9396363 0 1.24600873 19.2644065 1.24600873 19.2644065 6.00349662 6.54149628 6.00349662 6.54149628 10.5344375 18.4242143 10.5344375 18.4242143 15.2919253 6.54149628 15.2919253 6.54149628 21.1255117 20.3446536 21.1255117 20.3446536 25.9396363"
              />
              <polygon
                id="X"
                fillRule="nonzero"
                points="32.2873853 12.6866344 23.6454086 1.24600873 31.5672206 1.24600873 36.3683188 8.77869788 41.1094033 1.24600873 48.9111878 1.24600873 40.3292248 12.6866344 50.3515173 25.9396363 42.3696915 25.9396363 36.3683188 16.7078444 30.1268911 25.9396363 22.2050791 25.9396363"
              />
              <path
                d="M58.9334803,5.83358634 L64.274702,5.83358634 C67.2753884,5.83358634 68.4756629,7.19286859 68.4756629,9.62824929 C68.4756629,11.5538991 67.3954159,13.3662755 64.4547432,13.3662755 L58.9334803,13.3662755 C58.9334803,13.3662755 58.9334803,5.83358634 58.9334803,5.83358634 Z M52.391984,25.9396363 L58.993494,25.9396363 L58.993494,17.9538531 L64.0946608,17.9538531 C73.0367062,17.9538531 75.0171592,12.9131814 75.0171592,9.62824929 C75.0171592,4.75748789 72.436569,1.24600873 65.3549491,1.24600873 L52.391984,1.24600873 L52.391984,25.9396363 Z"
                id="P"
                fillRule="nonzero"
              />
              <path
                d="M83.2990536,5.83358634 L89.3004263,5.83358634 C91.4009068,5.8902231 92.7812225,6.85304802 92.7812225,9.17515521 C92.7812225,11.4406256 91.4009068,12.4600873 89.3004263,12.5167241 L83.2990536,12.5167241 L83.2990536,5.83358634 Z M76.7575573,25.9396363 L83.2990536,25.9396363 L83.2990536,17.0476649 L87.4400008,17.0476649 L92.6011814,25.9396363 L99.9228561,25.9396363 L93.9214834,16.0282032 C97.1622246,15.1220151 99.3227188,12.5733608 99.3227188,9.34506549 C99.3227188,3.79466296 95.7218952,1.24600873 89.8405499,1.24600873 L76.7575573,1.24600873 C76.7575573,1.24600873 76.7575573,25.9396363 76.7575573,25.9396363 Z"
                id="R"
                fillRule="nonzero"
              />
              <polygon
                id="E_1_"
                fillRule="nonzero"
                points="101.903309 25.9396363 101.903309 1.24600873 121.167716 1.24600873 121.167716 6.00349662 108.444805 6.00349662 108.444805 10.5344375 120.327523 10.5344375 120.327523 15.2919253 108.444805 15.2919253 108.444805 21.1255117 122.247963 21.1255117 122.247963 25.9396363"
              />
              <path
                d="M128.849473,18.5768575 C131.129994,20.5025073 133.290489,21.6352425 136.411202,21.6352425 C138.1516,21.6352425 141.272314,20.9556014 141.272314,18.8034045 C141.272314,17.5573958 140.252081,16.9343914 138.331642,16.5945708 L132.870392,15.7450194 C128.009281,15.0087415 125.368677,12.5733608 125.368677,8.94860816 C125.368677,3.00174831 130.469843,0.509730845 136.05112,0.509730845 C140.372108,0.509730845 144.633083,2.1521969 147.573756,5.26721873 L142.592616,8.6087876 C140.852218,6.62650098 138.331642,5.49376577 135.57101,5.49376577 C134.070667,5.49376577 131.850159,6.39995394 131.850159,7.98578324 C131.850159,9.28842873 132.99042,9.96806985 135.510996,10.3645272 L138.031573,10.7609845 C143.252767,11.5538991 147.573756,13.0830917 147.573756,17.7839428 C147.573756,25.2033584 140.492136,26.5626407 135.57101,26.5626407 C131.129994,26.5626407 127.34913,25.2033584 123.80832,21.521969 L128.849473,18.5768575 Z"
                id="S"
                fillRule="nonzero"
              />
              <path
                d="M154.055238,18.5768575 C156.33576,20.5025073 158.496254,21.6352425 161.616968,21.6352425 C163.357366,21.6352425 166.47808,20.9556014 166.47808,18.8034045 C166.47808,17.5573958 165.51786,16.9343914 163.537407,16.5945708 L158.136172,15.7450194 C153.27506,15.0087415 150.634456,12.5733608 150.634456,8.94860816 C150.634456,3.00174831 155.735623,0.566367605 161.316899,0.566367605 C165.637888,0.566367605 169.898862,2.20883366 172.839535,5.32385549 L167.858395,8.66542436 C166.117997,6.68313774 163.597421,5.55040253 160.836789,5.55040253 C159.336446,5.55040253 157.115938,6.4565907 157.115938,8.04242 C157.115938,9.34506549 158.256199,10.0247066 160.776776,10.4211639 L163.297352,10.8176213 C168.518546,11.6105359 172.839535,13.1397284 172.839535,17.8405796 C172.839535,25.2599952 165.757915,26.6192775 160.896803,26.6192775 C156.455787,26.6192775 152.674922,25.2599952 149.134113,21.5786058 L154.055238,18.5768575 Z"
                id="S_1_"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ExpressLogo;
